export const TOGGLE_CONFIRMATION_LEAVING_SPOT = 'TOGGLE_CONFIRMATION_LEAVING_SPOT'

export function displayConfirmationLeavingSpotReducer(state = false, action) {
    switch (action.type){
        case TOGGLE_CONFIRMATION_LEAVING_SPOT:
            return action.payload
        default: return state
    }
}